(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("netlify-cms", [], factory);
	else if(typeof exports === 'object')
		exports["netlify-cms"] = factory();
	else
		root["netlify-cms"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition